/* ============================================================
   SKIO SUBSCRIPTION BLOCK — JS ENHANCEMENTS
   Range Coffee
   
   Injects benefits grid and overrides radio button colors.
   Does NOT modify any Skio form elements.
   ============================================================ */

(function() {
  'use strict';

  var BENEFITS = [
    'Save 15% every month',
    'Modify or cancel anytime',
    'Free Range Coffee Hat',
    'Roasted in Laramie, WY'
  ];
  var CHECK_COLOR = '#1a1a1a';

  function checkSVG() {
    return '<svg width="15" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M3 8.5L6.5 12L13 4" stroke="' + CHECK_COLOR + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
  }

  function injectBenefits() {
    // Always target the first container (subscription), not --selected
    var subContainer = document.querySelector('fieldset.skio-plan-picker .skio-group-container:first-of-type');
    if (!subContainer) return false;
    if (subContainer.querySelector('.skio-custom-benefits')) return true;

    // Fix content overflow inline as backup
    var content = subContainer.querySelector('.skio-group-content');
    if (content) {
      content.style.maxHeight = 'none';
      content.style.overflow = 'visible';
      content.style.marginLeft = '0';
      content.style.width = '100%';
      content.style.opacity = '1';
    }

    var label = subContainer.querySelector('.skio-group-label');
    if (label) {
      label.style.overflow = 'visible';
    }

    // Build benefits grid
    var grid = document.createElement('div');
    grid.className = 'skio-custom-benefits';
    grid.style.pointerEvents = 'none';
    BENEFITS.forEach(function(text) {
      var item = document.createElement('div');
      item.className = 'skio-benefit-item';
      item.innerHTML = checkSVG() + '<span>' + text + '</span>';
      grid.appendChild(item);
    });

    if (content) {
      content.appendChild(grid);
    } else if (label) {
      label.appendChild(grid);
    }

    return true;
  }

  function fixRadioColors() {
    // Find all radio SVGs inside Skio and override their colors
    var selectedContainer = document.querySelector('fieldset.skio-plan-picker .skio-group-container--selected');
    if (!selectedContainer) return;

    // Override SVG radio circles
    var circles = selectedContainer.querySelectorAll('.skio-radio_container svg circle');
    circles.forEach(function(circle) {
      if (circle.getAttribute('fill') && circle.getAttribute('fill') !== 'none') {
        circle.setAttribute('fill', CHECK_COLOR);
      }
      if (circle.getAttribute('stroke') && circle.getAttribute('stroke') !== 'none') {
        circle.setAttribute('stroke', CHECK_COLOR);
      }
    });

    // Override any inline styles on radio container children
    var radioDivs = selectedContainer.querySelectorAll('.skio-radio_container div, .skio-radio_container span');
    radioDivs.forEach(function(el) {
      if (el.style.backgroundColor && el.style.backgroundColor !== 'transparent') {
        el.style.backgroundColor = CHECK_COLOR;
      }
      if (el.style.borderColor) {
        el.style.borderColor = CHECK_COLOR;
      }
    });
  }

  function enhance() {
    var result = injectBenefits();
    fixRadioColors();
    return result;
  }

  function init() {
    var attempts = 0;
    var interval = setInterval(function() {
      if (enhance() || attempts > 30) clearInterval(interval);
      attempts++;
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Watch for Skio re-renders and plan switches
  var observer = new MutationObserver(function() {
    var subContainer = document.querySelector('fieldset.skio-plan-picker .skio-group-container:first-of-type');
    if (subContainer && !subContainer.querySelector('.skio-custom-benefits')) {
      setTimeout(enhance, 150);
    }
    // Always try to fix radio colors on any change
    setTimeout(fixRadioColors, 100);
  });

  var formTarget = document.querySelector('form[action*="/cart"]') || document.body;
  observer.observe(formTarget, { childList: true, subtree: true, attributes: true });
})();